import type { ReactNode } from "react";
import { useTheme } from "../theme/ThemeProvider.js";

/**
 * Alternador de tema (Design.md §3.1 / §9): botão Claro/Escuro no cabeçalho.
 * Mostra o tema para o qual vai alternar.
 */
export function ThemeToggle(): ReactNode {
  const { theme, toggleTheme } = useTheme();
  const goingToDark = theme === "light";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={goingToDark ? "Ativar tema escuro" : "Ativar tema claro"}
      title={goingToDark ? "Tema escuro" : "Tema claro"}
      style={{
        background: "transparent",
        border: "1px solid var(--nav-text-muted)",
        color: "var(--nav-text)",
        borderRadius: 8,
        padding: "0.35rem 0.7rem",
        fontSize: 12,
        fontWeight: 600,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "0.4rem"
      }}
    >
      <span aria-hidden>{goingToDark ? "🌙" : "☀️"}</span>
      {goingToDark ? "Escuro" : "Claro"}
    </button>
  );
}
